import { render, staticRenderFns } from "./phone_field.vue?vue&type=template&id=dc97abd0&lang=pug&"
import script from "./phone_field.vue?vue&type=script&lang=js&"
export * from "./phone_field.vue?vue&type=script&lang=js&"
import style0 from "./phone_field.vue?vue&type=style&index=0&id=dc97abd0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports